// Display helpers for the Backups page.
//
// These live outside BackupManagementPage.tsx so they can be unit-tested: the
// admin vitest environment is `node`, so a test cannot import the page module
// (it pulls in @bbpos/ui and React). Same reason next-scheduled-backup.ts is a
// sibling module rather than an inline helper.

/** Render an ISO timestamp in IST, or an em dash when there is nothing to show. */
export function formatTimestamp(iso: string | null): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}

/**
 * Render a byte count.
 *
 * Only `null` means "unknown" — a real 0 renders as "0.0 B". Collapsing the two
 * made an empty backup indistinguishable from a missing one, and made a history
 * of nothing but failures look like a page that had failed to load.
 */
export function formatBytes(bytes: number | null): string {
  if (bytes === null || bytes === undefined) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let i = 0;
  let size = bytes;
  while (size >= 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }
  return `${size.toFixed(1)} ${units[i]}`;
}
